import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { MenusDataService, MenusColumnsService } from '../../../services';
import { Menu, MenusResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-menu-details',
  templateUrl: './menu-details.component.html',
  styleUrls: ['./menu-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class MenuDetailsComponent implements OnInit, OnDestroy {

  public menu: Menu = {};
  public menus: Menu[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private menusDataService: MenusDataService,
    private menusColumnsService: MenusColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Menu - Details');
        this.getMenu(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.menu !== 'undefined') {
      this.menu = this.dynamicDialogConfig.data.menu;
    }
    this.columns = this.menusColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getMenu(id: number): void {
    this.isLoading = true;
    this.menusDataService.getMenu(id).subscribe((response: Menu|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.menu = response;
      }
    });
  }

  list() {
    this.router.navigate(['/menus']);
  }

  add() {
    this.router.navigate(['/menus/add']);
  }

  edit() {
    this.router.navigate(['/menus/edit/' + this.menu.id]);
  }

}
@Component({
  selector: 'app-menu-details',
  templateUrl: './menu-details.component.html',
  styleUrls: ['./menu-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogMenuDetailsComponent extends MenuDetailsComponent {
}

